<template>
  <v-app>
    <!-- <core-filter /> -->
    <span v-if="!hideToolbar()">
      <core-toolbar/>
      <core-drawer />
    </span>
    <core-view />
  </v-app>
</template>
<script>
export default {
  data(){
    return{
      noToolbar:['Main', 'Login', 'Success','CompanyAnalytics'],
      isLoggedIn: true
    }
  },
  methods:{
    hideToolbar(){
      for(var x = 0; x < this.noToolbar.length; x++){
        if(this.$route.name == this.noToolbar[x]){
          return true;
        }
      }
    }
  },

}
</script>
<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
